// Phase 10e — facility AR payment recording for the operator admin.
//
// Q9 lock: facility AR is operator-managed (cheque / EFT / wire / PAD).
// This endpoint records a payment received out-of-band against an
// existing invoice; transitions the invoice toward PAID; and (via the
// 10e-5 auto-clear hook) flips Facility.creditHoldStatus → NONE when
// all the facility's overdue invoices are squared away.
import { z } from 'zod';
export const FacilityPaymentMechanicSchema = z.enum([
    'CHEQUE',
    'EFT',
    'WIRE',
    'PAD',
    'MANUAL_CREDIT',
]);
export const RecordFacilityPaymentRequestSchema = z.object({
    mechanic: FacilityPaymentMechanicSchema,
    amountCents: z.number().int().positive(),
    externalRef: z.string().min(1).max(120),
    receivedAt: z
        .string()
        .regex(/^\d{4}-\d{2}-\d{2}$/, 'receivedAt must be YYYY-MM-DD')
        .optional(),
    operatorNote: z.string().min(10).max(500),
});
export const RecordFacilityPaymentResponseSchema = z.object({
    invoiceId: z.string().uuid(),
    paymentEventId: z.string().uuid(),
    amountPaidCents: z.number().int().min(0),
    invoiceStatus: z.enum(['ISSUED', 'PARTIAL', 'PAID', 'OVERDUE']),
    creditHoldCleared: z.boolean(),
});
//# sourceMappingURL=facility-payment-admin.schema.js.map